<template>
  <div class="main-body">
    <div class="header">智能网关</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">绑定设备</el-button>

          <div style="float:right">

            <el-input placeholder="输入老人姓名" v-model="name" clearable style="margin:0 5px;width:120px"></el-input>
            <el-input placeholder="输入网关号" v-model="gatewayId" clearable style="margin:0 5px;width:140px"></el-input>
            <el-input placeholder="输入手机号" v-model="phone" clearable style="margin:0 5px;width:140px"></el-input>

            <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                          placeholder="选择区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                          style="width:140px;margin-right:10px"></elSelectTree>

            <el-button size="mini" style="margin-left:5px;float:right" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
          </div>


        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">
        <el-table-column prop="userName" label="用户名" width="100"></el-table-column>

        <el-table-column prop="phone" label="手机号" width="150" :formatter="getPhoneStr"></el-table-column>

        <el-table-column prop="gatewayId" label="网关号" width="100"></el-table-column>

        <el-table-column prop="bindTime" label="绑定时间" :formatter="timefilter" width="180"></el-table-column>
        <el-table-column prop="zoneCodePathName" label="所在区域" width="300" ></el-table-column>
        <el-table-column prop="address" label="住址" width="300" ></el-table-column>

        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="getMeshDevice(scope.$index, scope.row)">Mesh设备</el-button>
            <el-button type="success" size="mini" @click="getData(scope.$index, scope.row)">报警数据</el-button>
            <el-button type="danger" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
            background
            layout="prev, pager, next"
            :total="totalItems"
            :page-size="20"
            :current-page.sync="currentPage"  @current-change="current_change"
          ></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false" v-on:getList="getList"></Add>
    <MeshDevicePage ref="myMeshDevicePage" v-show="showModalMeshDevicePage" v-on:closeMeshDevicePage="closeMeshDevicePage"></MeshDevicePage>
    <PushData ref="WangGuanData" v-show="wangGuanDataShow" v-on:closeWangGuanData="closeWangGuanData"></PushData>

  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import MeshDevicePage from "./MeshDevicePage";
import PushData from "./PushData";
import Add from "./Add"
import elSelectTree from "@/components/ElSelectTree"

export default {
  name: "Role",
  data() {
    return {
      tableLoading:false,
      showModalAdd:false,
      showModalMeshDevicePage:false,
      wangGuanDataShow:false,

      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      name:'',
      phone: "",
      gatewayId: "",

      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      zoneValue: [],
      zoneCode: '',


    };
  },
  components: {Add,MeshDevicePage,PushData,elSelectTree},
  created() {
    this.getZone();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalAdd: function () {
        this.$refs.myAdd.init();
        this.showModalAdd = !this.showModalAdd;
    },

    getPhoneStr(row,index,column){
      let str = "";
      if(column && column.length == 11){
        str = column.substring(0,3)+"****"+column.substring(7,11);
      }else{
        str = column;
      }
      return str;
    },



    closeGetElderly: function () {
        this.showModalGetElderly = !this.showModalGetElderly;
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    closeMeshDevicePage(){
      this.showModalMeshDevicePage =!this.showModalMeshDevicePage;
    },



    getData(index,row){
      this.$refs.WangGuanData.init(row.userCode);
      this.wangGuanDataShow =!this.wangGuanDataShow;
    },
    closeWangGuanData(){
      this.wangGuanDataShow =!this.wangGuanDataShow;
    },

    getMeshDevice(index,row){
        this.$refs.myMeshDevicePage.init(row.userCode);
        this.showModalMeshDevicePage = !this.showModalMeshDevicePage;
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceYjgateway/PageByZoneCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,

          phone: this.phone,
          gatewayId: this.gatewayId,
          name:this.name,
          zoneCode:this.zoneCode,

        },
      }).then((response) => {
          this.tableLoading=false
          if (response.data.error == 0) {
            this.tableData = response.data.data.list;
            this.totalItems = response.data.data.total;
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          this.tableLoading=false
          console.log(error);
        });

    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
            this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceYjgateway/Delete",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceYjgatewayCode: row.deviceYjgatewayCode,
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            this.$message({
              message: "解绑成功",
              type: "success",
            });
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消解绑",
          });
        });
    },

    getZone(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        //console.log(response.data.data);
        if (response.data.error == 0) {
          var data = JSON.stringify(response.data.data);

          //console.log(data.replace(/"listZoneDTO":\[\],/g, ''));

          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;
          this.zoneCode = data[0].zoneCode;

          this.getList();

        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },


    getZoneValue(val) {
      this.zoneCode = val
    },

  },
};
</script>

<style scoped>
</style>
